export default "__VITE_ASSET__aa06361c__"